import {
  Button,
  createStyles,
  makeStyles,
  Theme,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { API, graphqlOperation } from "aws-amplify";
import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCookieValue } from "../../../../cookieHelper";
import translate from "../../../../i18n/translate";
import { PostRenewalData } from "../../../../queries";
import allActions from "../../../../redux/actions";
import RollbarErrorTracking from "../../../../utils/RollbarErrorTracking";
import "./RenewalIntercept.scss";

const RenewalIntercept = (props: any) => {
  const dispatch = useDispatch();
  const allInfo = useSelector((state: any) => state);
  const [radiobutton, setRadioButton] = useState(0);
  const [submitEnable, setSubmitEnable] = useState(false);
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
          borderColor: "#42BABD",
        },
      },
      continueButton: {
        width: "auto",
        margin: "15px auto",
        height: "auto",
      },
    })
  );

  const handleSubmit = async () => {
    if (Number(radiobutton) === 0) {
      const userLang = getCookieValue("ulang") || "";
      let userId = sessionStorage.getItem("leuId") || "1111";
      const surveyUrl = encodeURIComponent(
        `${
          process.env.REACT_APP_CORP_ENDPOINT
        }/templates/bin/template.asp?lang=${userLang.toUpperCase()}&ClassId=345&ObjectId=229143&layout=4&surveybackoption=1`
      );
      const surveyInterceptUrl = `${
        process.env.REACT_APP_CORP_ENDPOINT
      }/templates/bin/interceptpage/intercepthandler.asp?geedgeUid=${userId}&key=${sessionStorage.getItem(
        "hashKey"
      )}&redirect=${surveyUrl} `;
      window.location.href = surveyInterceptUrl;
    }
    const status: number = radiobutton;
    const userId: number = parseInt(sessionStorage.getItem("leuId") || "1234");
    const latestRenewalDate = API.graphql(graphqlOperation(PostRenewalData(userId, status))) as Promise<any>;
    latestRenewalDate
      .then(async () => {
        dispatch(allActions.commonActions.setRenewalInterceptRequired(false));
        sessionStorage.setItem("RenwalIntercept", "false");
        if (Number(radiobutton) === 1) {
          dispatch(allActions.renewalInformationAction.getStoreRenewalInfo(userId));
        }
        dispatch(allActions.toasterActions.showToastMessage(true, "success", "message_welcomeSubmitted"));
        props.setLoaderFlag(true);
        const loaderHandle = setInterval(() => {
          props.setLoaderFlag(false);
        }, 1000);
      })
      .catch((err) => {
        dispatch(allActions.toasterActions.showToastMessage(true, "error", "message_errorDefault"));
        RollbarErrorTracking.logErrorInRollbar(err.message, "error");
      });

    // API call to submit the values PostRenewalData
  };
  const handleToggle = (event: any) => {
    setSubmitEnable(true);
    setRadioButton(event.target.value);
  };
  const handleLaterClick = () => {
    dispatch(allActions.commonActions.setRenewalInterceptRequired(false));
    sessionStorage.setItem("RenwalIntercept", "skip");
  };
  const classes = useStyles();
  return (
    <div className="renewal-intercept-container">
      <div className="renewal-intercept-profile-container">
        <div className="renewal-intercept-profile-form-container">
          <div className="renewal-intercept-form-row">
            <div className="renewal-intercept-form-input">
              <Typography className="renewal-text">
                {" "}
                {translate("renewal_welcome")} {allInfo.peopleInformation.data ? allInfo.peopleInformation.data.getpeopleInformation.firstName : ""}
              </Typography>
            </div>
          </div>
          <div className="renewal-form-input">
            <div className="renewal-intercept-para-input">
              <Typography className="renewal-text-para">
                {" "}
                {translate("renewal_text", {
                  date: moment.unix(parseInt(sessionStorage.getItem("RenewalEndDate") || "0000")).format("DD"),
                  month: translate(
                    moment.unix(parseInt(sessionStorage.getItem("RenewalEndDate") || "0")).format("MMMM")
                  ),
                  year: moment.unix(parseInt(sessionStorage.getItem("RenewalEndDate") || "0")).format("YYYY"),
                })}{" "}
              </Typography>
            </div>
          </div>
          <div className="renewal-radio-button">
            <FormControl component="fieldset" className="renewal-fieldset">
              <RadioGroup aria-label="gender" name="gender1">
                <FormControlLabel
                  onClick={handleToggle}
                  value="1"
                  control={<Radio />}
                  label={
                    <React.Fragment>
                      <strong>{translate("renewal_yes")}</strong>, {translate("renewal_affirmative")}
                    </React.Fragment>
                  }
                />
                <FormControlLabel
                  onClick={handleToggle}
                  value="0"
                  control={<Radio />}
                  label={
                    <React.Fragment>
                      <b>{translate("renewal_no")}</b>, {translate("renewal_negative")}
                    </React.Fragment>
                  }
                />
              </RadioGroup>
            </FormControl>
          </div>

          <div className="intercept-btn"
          >
            <Button
              onClick={handleSubmit}
              disabled={!submitEnable}
              variant="contained"
              size="large"
              color="primary"
              className={classes.continueButton}
            >
              {translate("SessionRating_submit")}
            </Button>
            <a className="renewal-link" onClick={handleLaterClick}>
              {translate("renewal_later")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenewalIntercept;
